
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util';
	import wx from 'weixin-js-sdk';
	import AbpBase from '@/lib/abpbase';
	import Viewer from 'v-viewer'
	import 'viewerjs/dist/viewer.css'
	@Component({
		components: {

		}
	})
	export default class NoticeDetail extends AbpBase {
		news: Object = new Object() as any;
		noticeid: number = 0;
		pageSize: number = 10;
		pageIndex: number = 1;
		userid: number = 0;
		commentBox: boolean = false;
		commentList: Array < Object >= new Array < Object > ();
		commentContent: string = "";
		loadmore: boolean = true;
		imgBox: boolean = false;
		currentImgs: Array < Object >= new Array < Object > ();
		currentImgUrl: string = '';
		optertionInfo: Object = {
			likeId: 0,
			isLike: false,
			followId: 0,
			isFollow: false
		};
		userInfo: Object = new Object();
		anonymous: boolean = false;

		showShare: boolean = false;
		shownews: number = 0; // 0加载中 1 可见 2 不可见
		msg: string = '';
		isPreview: boolean = false;
		screenWidth:number=0;
		
		isEn: boolean = false;
		mycontent:string='';
		domainAccount:string='';

		getNewsByID() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getNewsById',
				id: this.noticeid
			}).then((res) => {
				console.log(res);
				that.news = res as any;
				if (that.userid == 0 && !that.isPreview) {
					if ((that.news as any).externalView != null && (that.news as any).externalView) {
						that.shownews = 1;
					} else {
						that.shownews = 2;
					}
				} else {
					that.shownews = 1;
					var date = (that.news as any).publishTime;
					if (date == null) {
						date = (that.news as any).creationTime;
					}
					(that.news as any).time = Util.formatDate(new Date(date), 'yyyy-MM-dd hh:mm:ss');

				}
				
	
				
				 that.mycontent=that.isEn?((that.news as any).contentEn==null||(that.news as any).contentEn==""?(that.news as any).content:(that.news as any).contentEn):(that.news as any).content;
				 
				 setTimeout(function() {					 
					 let as = document.getElementsByClassName('newscot')[0].getElementsByTagName('a');
					 for (var i = 0; i < as.length; i++) {
					 	var img = as[i] as any;
					 	img.onclick = function(e) {
					 		var href=e.currentTarget.href;						
					 		var url = that.changeUrlArg(href, 'domain', that.domainAccount);	
					 		e.currentTarget.href=url;
							console.log(url);
					 	}
					 }
				 }, 500);
				 
				
				 
				
			})
		}
		writeNewsReadLog() {
			var that = this;
			this.$store.dispatch({
				type: 'app/writeNewsReadLog',
				data: {
					id: that.noticeid
				}
			}).then((res) => {

			})
		}
		

		getLoginUser() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getLoginUser',
				data: {}
			}).then(res => {
				that.userInfo = res;
				var phonenumber=res.phoneNumber;
				that.getLoginUserDomainAccount(phonenumber);
			})
		}
		getLoginUserDomainAccount(phonenumber) {
			var that = this;
			this.$store.dispatch({
				type: 'user/getUserByUserName',
				data: {
					name:phonenumber
				}
			}).then(res2 => {					
				that.domainAccount=res2.domainAccount;
				console.log("domainAccount:"+that.domainAccount)
			})
		}
		
		changeUrlArg(url, arg, val) {
			var pattern = arg + '=([^&]*)';
			var replaceText = arg + '=' + val;
			return url.match(pattern) ? url.replace(eval('/(' + arg + '=)([^&]*)/gi'), replaceText) :
				(url.match('[\?]') ? url + '&' + replaceText : url + '?' + replaceText);
		}
		
		@Watch('$route')
		routechange(to: any, from: any) {
			if (to.query.noticeid != from.query.noticeid) {
				location.reload();
			}
		}

		async created() {
			var that=this;
			that.screenWidth = document.body.clientWidth
			console.log(that.screenWidth)

			if (!Util.abp.session.userId) {
				var domain = this.$route.query.domain as any;
				if (domain != undefined && domain != null && domain != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSDOMAIN",
							"ProviderAccessCode": domain,
							ProviderKey: "",
							Property: ""
						},
					})
					location.reload();
				}
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSID",
							"ProviderAccessCode": userId,
							ProviderKey: userId,
							Property: ""
						},
					})
					location.reload();
				}
			}
			
			if (this.$route.query.isen && (this.$route.query.isen as any) == 1) {
				this.isEn=true;
			}
			
			
			
			if (this.$route.query.noticeid && (this.$route.query.noticeid as any) > 0) {
				this.noticeid = this.$route.query.noticeid as any;
				console.log(Util.abp.session.userId);
				if (Util.abp.session.userId) {
					this.userid = Util.abp.session.userId;					
					this.getLoginUser();
					this.writeNewsReadLog();
				}
				if (this.$route.query.preview && (this.$route.query.preview as any) > 0) {
					this.isPreview = true;
				}
				this.getNewsByID();
			}


		}
		mounted() {
			var that=this;
			setTimeout(function() {
				var u = navigator.userAgent.toLowerCase();
				//统一使用组件方式查看图片可以缩放
				if (1==1 || u.indexOf('iphone os 13_4') > -1 || u.indexOf('iphone os 14') > -1 || u.indexOf('ipad') > -1 || u.indexOf('ipod') > -1 || that.screenWidth>=768) {
					let imgs = document.getElementsByClassName('newscot')[0].getElementsByTagName('img');
					for (var i = 0; i < imgs.length; i++) {
						var img = imgs[i] as any;
						img.onclick = function(e) {
							// that.currentImgUrl = e.currentTarget.src;
							// that.currentImgs = [];
							// that.currentImgs.push(that.currentImgUrl);
							// that.imgBox = true;
							// that.$forceUpdate();
							//(window as any).gis.previewImage([e.currentTarget.src]);
							that.currentImgUrl = e.currentTarget.src;
							that.currentImgs = [];
							that.currentImgs.push(that.currentImgUrl);
							//that.imgBox = true;
							const ViewerDom = document.getElementById('viewer');
							((ViewerDom as any).viewer as any).options.title = false;
							((ViewerDom as any).viewer as any).options.navbar = false;
							((ViewerDom as any).viewer as any).options.toolbar=false;
							((ViewerDom as any).viewer as any).images= that.currentImgs;													
							setTimeout(function(){
								var contain=document.getElementsByClassName('descimgBox')[0].getElementsByTagName('img');;
								if(contain!=null && contain.length>0){
									 contain[0].click();
								 }
							},300)
						}
						// img.ontouchend = function(e) {
						// 	(window as any).gis.previewImage([e.currentTarget.src]);
						// }
					}

				} else {
					let imgs = document.getElementsByClassName('newscot')[0].getElementsByTagName('img');
					for (var i = 0; i < imgs.length; i++) {
						var img = imgs[i] as any;
						img.onclick = function(e) {
							(window as any).gis.previewImage([e.currentTarget.src]);
						}
					}
				}
			}, 2000)
		}
	};
